"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function joinUrl(...items) {
    return items.reduce((prev, current) => {
        if (current.length === 0) {
            return prev;
        }
        let url = appendSlash(prev);
        return url + current;
    }, '');
}
exports.joinUrl = joinUrl;
function appendSlash(url) {
    if (url.length > 0 && !url.endsWith('/')) {
        return url + '/';
    }
    return url;
}
exports.appendSlash = appendSlash;
//# sourceMappingURL=join-url.js.map